
import {User} from "./users";
export const isBookedKeyAvailable = (user: User|undefined, key: any): boolean => {
  if (!key?.currentBooking) {
    return true;
  }
  const isCreator = user.id === key.currentBooking.createdBy;
  const isTargetUser = user.id === key.currentBooking.userId;
  const isManager = !!key.legitimateKeyAccess?.keyManagementId;
  return isCreator || isTargetUser || isManager;
};
